import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, IconButton } from "@material-ui/core/";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import PropTypes from "prop-types";
import { Box, MenuItem } from "@material-ui/core";
import WebHookForm from "./WebHookForm";
import triggerService from "../../../../services/triggerService/triggerService";
import UserService from '../../../../services/UserService/UserService';
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../recoil-store/recoil-state';
import InsertLinkIcon from '@material-ui/icons/InsertLink';
import TextFieldInput from '../../../../components/TextField/TextField';
import { Tooltip } from '@material-ui/core';
import Delete from "@material-ui/icons/Delete";
import DeleteWebhook from "../../webhookRule/deleteWebhook/DeleteWebhook";

// TabPanel styling
function TabPanel({ children, value, index }) {
    return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

const action = {
    fields: {
        name: { value: "" },
        description: { value: "" },
        sourceValue: { value: "" },
        operator: { value: "" },
        targetValue: { value: "" },
        params: { value: "" },
    },
};

const WebHook = (props) => {
    const { t } = useTranslation();
    const setAlert = useSetRecoilState(alertState);

    const [value, setValue] = useState(0);
    const [open, setOpen] = useState(false)
    const [rules, setRules] = useState([]);
    const [triggerProfile, setTriggerProfile] = useState([]);
    const [select, setSelect] = useState("");
    const [ruleList, setRuleList] = useState([]);
    const [apiKey, setApiKey] = useState("");
    const [webhookUrl, setWebhookUrl] = useState("");

    useEffect(() => {
        action.fields.name.value = "";
        action.fields.description.value = "";
        action.fields.sourceValue.value = "";
        action.fields.targetValue.value = "";
        action.fields.operator.value = "";
        action.fields.params.value = "";

        const fetchData = async () => {
            const responseList = await triggerService.getRules();
            if (responseList) {
                if (responseList?.data) {
                    if (Array.isArray(responseList?.data)) {
                        setRuleList(responseList?.data);
                    }
                }
            }
            const resp = await triggerService.getTriggerProfileByAutomId(
                props.automId,
                "WEBHOOK"
            );
            if (resp && resp.status && resp.code === 200) {
                if (resp?.data?.trigger_rule) {
                    setRules(resp.data.trigger_rule.configuration);
                    action.fields.name.value = resp.data.trigger_rule.name;
                    action.fields.description.value = resp.data.trigger_rule.description;
                    action.fields.id = resp.data.trigger_rule.id;
                    setValue(1);
                } else {
                    setSelect(resp?.data?.trigger_rule_id)
                    setValue(0);
                }
                setTriggerProfile(resp.data);
            }
        };

        setWebhookUrl(`${window.location.protocol}//${window.location.hostname}:2096/api/v1/${props.webhook}/run/${props.automId}`);
        getAPIKey().then(r => r);
        fetchData().then((r) => r);
    }, [apiKey]);

    const getAPIKey = async () => {
        let response = await UserService.getAPIKey();
        if (response?.status) {
            setApiKey(response?.data?.apiKey);
            const newWebhookUrl = `${webhookUrl}?apiKey=${apiKey}`
            setWebhookUrl(newWebhookUrl)
        }
    }


    const handleClose = () => {
        props.setOpen(false);
    };

    const handleChange = (newValue) => {
        setValue(newValue);
    };

    const handleNewData = (isPrivate) => {
        let newData = {
            autom_id: props.automId,
            configuration: rules,
            period: "",
            type: "WEBHOOK",
            private: isPrivate,
            name: action.fields.name.value.trim(),
            description: action.fields.description.value,
            tab: "custom",
        };

        if (triggerProfile?.trigger_profile_id) {
            newData.trigger_profile_id = triggerProfile.trigger_profile_id
        }
        if (triggerProfile.id) {
            newData.trigger_profile_id = triggerProfile.id
        }
        if (triggerProfile.trigger_rule?.id) {
            newData.trigger_rule_id = triggerProfile.trigger_rule?.id
        }

        return newData;
    };

    const handleAdd = async () => {

        if (select?.length > 0) {
            const response = await triggerService.createProfile({
                autom_id: props.automId,
                type: "WEBHOOK",
                trigger_rule_id: select,
                tab: "static",
                trigger_profile_id: triggerProfile?.trigger_profile_id ? triggerProfile?.trigger_profile_id : triggerProfile?.id
            });

            if (response) {
                if (response?.status) {
                    setAlert(alert => ({ ...alert, show: true, message: t("CONTENT.WEBHOOK.ADD-SUCCESS"), severity: 'success' }))
                    props.setOpen(false);
                }
            }
        }
    };

    const handleCreate = async (isPrivate) => {
        if (!action.fields.name) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('CONTENT.WEBHOOK.RULE-NAME-MANDATORY'),
                severity: 'error'
            }));
            return;
        } else if (action.fields.name.value.trim().length < 3) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t('CONTENT.WEBHOOK.RULE-NAME-LENGTH'),
                severity: 'error'
            }));
            return;
        }

        // if not created before trigger profile
        const response = await triggerService.createProfile(
            handleNewData(isPrivate)
        );
        if (response) {
            setAlert(alert => ({ ...alert, show: true, message: t("CONTENT.WEBHOOK.ADD-SUCCESS"), severity: 'success' }))
        }

        props.setOpen(false);
    }

    const handleFocus = (event) => event.target.select();

    const handleSelectDropdown = (event) => {
        setSelect(event.target.value);
    };

    const handleCopy = () => {
        try {
            const textBox = document.getElementById("auTextInput");
            textBox.select();
            document.execCommand("copy");
            props.showNewAlert(t('MESSAGES.AUTOMS.AUTOM-COPIED'), true);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }
    }
    const handleDelete = async () => {
        const res = await triggerService.deleteRules([action.fields.id]);
        if (res?.status) {
            setOpen(false);
            props.setOpen(false);
        }
        setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.WEBHOOK." + res.message), severity: res.status ? 'success' : 'error' }))
    }
    return (
        <Dialog
            id="autom-addNew-modal"
            className="user-detail-dialog"
            data-test="autom-add-new"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    overflowX: "hidden",
                    minWidth: 400,
                },
            }}>
            <div className="db-tabs db-page">
                <button className={props.tab === 0 ? 'db-tabactive' : ''} value="license"
                    onClick={() => props.onTabChange("email")}>
                    {t("CONTENT.EMAIL-TRIGGER.EMAIL-CONFIGURATION")}
                </button>
                <button className={props.tab === 1 ? 'db-tabactive' : ''} value="about"
                    onClick={() => props.onTabChange("webhook")}>
                    {t("CONTENT.WEBHOOK.ADD-RULE")}
                </button>
            </div>
            <DialogContent style={{ paddingLeft: 30, paddingRight: 10 }}>
                <div className="form-element">
                    <div className="condition-tabs" style={{ display: 'inline' }}>
                        <button
                            className={value === 0 ? "condition-active" : ""}
                            onClick={() => handleChange(0)}
                        >
                            {t("CONTENT.WEBHOOK.STATIC")}
                        </button>
                        <button
                            className={value === 1 ? "condition-active" : ""}
                            onClick={() => handleChange(1)}
                        >
                            {t("CONTENT.WEBHOOK.CUSTOM")}
                        </button>
                    </div>
                    <IconButton size="small" onClick={() => setOpen(true)}
                        style={{ float: 'right', marginTop: 5, marginRight: 30 }}>
                        <Delete fontSize="small" />
                    </IconButton>
                    <TabPanel value={value} index={0}>
                        <p>{t("CONTENT.WEBHOOK.URL")}</p>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ flexBasis: "70%" }}>
                                <TextFieldInput
                                    onFocus={handleFocus}
                                    value={webhookUrl}
                                    width="100%"
                                />
                            </div>
                            <div style={{ width: 32, cursor: 'pointer', marginLeft: 5 }}>
                                <Tooltip title={t("CONTENT.WEBHOOK.COPY")}>
                                    <InsertLinkIcon onClick={handleCopy} />
                                </Tooltip>
                            </div>
                        </div>
                        <div className="form-element">
                            <p>Choose Trigger Rule Set</p>
                            <div className="form-element">
                                <FormControl variant="outlined" style={{ width: "90%" }}>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined"
                                        value={select}
                                        onChange={handleSelectDropdown}
                                        style={{
                                            height: 34,
                                            fontSize: 12,
                                            color: "#8F94A6",
                                            fontWeight: "800",
                                        }}
                                    >
                                        <MenuItem
                                            style={{
                                                fontSize: 12,
                                                color: "#8F94A6",
                                                fontWeight: "800",
                                            }}
                                            value=""
                                        >
                                            none
                                        </MenuItem>
                                        {ruleList &&
                                            ruleList?.map((item, index) => (
                                                <MenuItem
                                                    key={index}
                                                    style={{
                                                        fontSize: 12,
                                                        color: "#8F94A6",
                                                        fontWeight: "800",
                                                    }}
                                                    value={item.id}
                                                >
                                                    {item.name}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <WebHookForm
                            action={action}
                            rules={rules}
                            setRules={setRules}
                            setOpenVariable={props.setOpenVariable}
                            isVariableAdd={true}
                            variables={props.variables}
                        />
                    </TabPanel>
                </div>
                {open && <DeleteWebhook setOpen={setOpen} deleteFunc={handleDelete} setRefresh={() => { }} />}
            </DialogContent>
            <DialogActions
                style={{
                    justifyContent: value === 0 ? "center" : "space-between",
                    padding: "8px 24px 16px 24px",
                }}
            >
                {value === 0 ? (
                    <>
                        <Button
                            onClick={handleClose}
                            style={{
                                background: "#D75E5E",
                                color: "#fff",
                                borderRadius: 4,
                                boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25);",
                                minWidth: 130,
                            }}
                        >
                            {t("CONTENT.AUTOMS-LIST.CLOSE")}
                        </Button>
                        <Button
                            onClick={handleAdd}
                            disabled={select === ''}
                            style={{
                                background: "#162436",
                                color: "#fff",
                                borderRadius: 4,
                                boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25);",
                                minWidth: 130,
                                opacity: select === '' ? .6 : 1
                            }}
                        >
                            {t("CONTENT.AUTOMS-LIST.SAVE")}
                        </Button>
                    </>
                ) : (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                        }}
                    >
                        <Button
                            onClick={() => handleCreate(false)}
                            disabled={rules.length < 1}
                            style={{
                                background: "#162436",
                                color: "#fff",
                                borderRadius: 4,
                                boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25);",
                                minWidth: 150,
                                opacity: rules.length < 1 ? .6 : 1
                            }}
                        >
                            {t("CONTENT.WEBHOOK.CREATE-USE")}
                        </Button>
                        <Button
                            onClick={() => handleCreate(true)}
                            disabled={rules.length < 1}
                            style={{
                                background: "white",
                                color: "#162436",
                                border: "1px solid #162436",
                                borderRadius: 4,
                                boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25);",
                                minWidth: 150,
                                opacity: rules.length < 1 ? .6 : 1
                            }}
                        >
                            {t("CONTENT.WEBHOOK.ONLY-USE")}
                        </Button>
                    </div>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default WebHook;
